import React, { useState } from "react";
import { Container, Box } from "@mui/material";
import {
  Users,
  Link2,
  Map,
  LogIn,
  FileText,
  DollarSign,
  MapPin,
  ArrowRightCircle,
  Phone,
  Clock,
} from "react-feather";

import Instructions from "components/Instructions";
import TimeComponent from "components/TimeComponent";
import LocationComponent from "components/LocationComponent";
import Address from "components/Address";
import Price from "components/Price";
import Time from "components/Time";
import Delivery from "components/Delivery";

const buttonData = [
  // { id: "register", label: "Бүртгүүлэх", icon: Users },
  // { id: "login", label: "Нэвтрэх", icon: LogIn },
  { id: "instructions", label: "Заавар сургалт", icon: FileText },
  { id: "address", label: "Хаяг холбох", icon: Map },
  // { id: "linkOrder", label: "Линк захиалга", icon: Link2 },
  { id: "pricing", label: "Үнийн мэдээлэл", icon: DollarSign },
  { id: "location", label: "Хаяг байршил", icon: MapPin },
  // { id: "delivery", label: "Хүргэлт", icon: ArrowRightCircle },
  // { id: "contact", label: "Холбоо барих", icon: Phone },
  { id: "schedule", label: "Цагийн хуваарь", icon: Clock },
];

const Most = ({ price, time, location, connect, training }) => {
  const [openModal, setOpenModal] = useState(null);

  // Open modal based on button ID
  const handleOpen = (id) => {
    setOpenModal(id);
  };

  // Close modal
  const handleClose = () => {
    setOpenModal(null);
  };

  return (
    <Container maxWidth="lg" className="mt-[30px]">
      <Box className="mt-[10px] flex flex-wrap justify-center w-full font-bold text-[34px] text-white font-[Arial]">
        {buttonData.map(({ id, label, icon: Icon }) => (
          <Box
            key={id}
            className="rounded-md h-[50px] pl-[18px] m-[10px] flex justify-left items-center text-gray-500 bg-gray-200 cursor-pointer 
            min-w-[290px] sm:min-w-[200px] md:min-w-[190px] lg:min-w-[220px] xl:min-w-[250px]"
            onClick={() => handleOpen(id)}
          >
            <Icon size={20} color={"#044ba1"} className="mr-[10px]" />
            <Box className="text-[#393c40] font-bold text-[15px] font-[Tahoma]">
              {label}
            </Box>
          </Box>
        ))}
      </Box>

      {/* Modals */}
      {openModal === "instructions" && (
        <Instructions inst={training} open={true} handleClose={handleClose} />
      )}
      {openModal === "location" && (
        <LocationComponent location={location}  open={true} handleClose={handleClose} />
      )}
      {openModal === "address" && (
        <Address connect={connect} open={true} handleClose={handleClose} />
      )}
      {openModal === "pricing" && (
        <Price open={true} price={price} handleClose={handleClose} />
      )}
      {openModal === "schedule" && (
        <Time open={true} time={time} handleClose={handleClose} />
      )}
      {/* {openModal === "delivery" && (
        <Delivery open={true} time={time} handleClose={handleClose} />
      )} */}
    </Container>
  );
};

export default Most;
